export default __webpack_public_path__ + "static/media/2010-AMcover.d554a377.png";